import { PickupPoint } from '@owl-nest/api-client/latest'
import * as env from '@owl-nest/config'
import { formatLine } from '@owl-nest/address/src/model'
import * as i18nUtils from './i18n'

export function city(pickupPoint: PickupPoint): string {
  return i18nUtils.get(pickupPoint.name, undefined, '')
}

export function address(pickupPoint: PickupPoint): string {
  return pickupPoint.address ? formatLine(pickupPoint.address, env.COUNTRIES) : ''
}

export function description(pickupPoint: PickupPoint): string {
  return i18nUtils.get(pickupPoint.description, undefined, '')
}

export function name(pickupPoint: PickupPoint): string {
  return i18nUtils.get(pickupPoint.name, undefined, '')
}
